const URLS = {
    'subscribe': (username: string) => `/${username}`,
    'sitemap': (username: string) => `/${username}/sitemap.xml`,
    'premium-rss': (username: string, id: string) => `/${username}/subscribers/${id}/rss`,
    'rss': (username: string) => `/${username}/rss`,
    'comments-rss': (username: string) => `/${username}/comments/rss`,
    'lifecycle-track-click': (compressed_id: string) => `/lc/${compressed_id}/`,
    'lifecycle-track-open': (compressed_id: string) => `/lo/${compressed_id}/`,
    'track-click': (compressed_id: string) => `/c/${compressed_id}/`,
    'track-open': (compressed_id: string) => `/o/${compressed_id}/`,
    'manage-subscription': (username: string, subscriber_id: string) => `/${username}/management/subscribers/${subscriber_id}/`,
    'sponsor-submit': (username: string, submission_token: string) => `/${username}/sponsorships/submit/${submission_token}/`,
    'sponsorship-success': (username: string) => `/${username}/sponsorships/success`,
    'sponsorship-inquiry': (username: string, sku_id: string, slot_id: string) => `/${username}/sponsorships/inquire/${sku_id}/${slot_id}`,
    'sponsorship-slots': (username: string, sku_id: string, slot_id: string) => `/${username}/sponsorships/slots/${sku_id}/${slot_id}`,
    'sponsorships': (username: string) => `/${username}/sponsorships`,
    'form-survey-responses': (username: string, form_slug: string) => `/${username}/forms/${form_slug}/survey-responses`,
    'form': (username: string, form_slug: string) => `/${username}/forms/${form_slug}/`,
    'webmanifest': (username: string) => `/${username}/webmanifest.json`,
    'confirm-subscription-invalid-id': (username: string, subscriber_id: string) => `/${username}/confirm-subscription/${subscriber_id}`,
    'confirm-subscription': (username: string, subscriber_id: string) => `/${username}/confirm-subscription/${subscriber_id}`,
    'unsubscribe': (subscriber_id: string) => `/unsubscribe/${subscriber_id}`,
    'unsubscription-success': (subscriber_id: string) => `/unsubscription-success/${subscriber_id}/`,
    'upgrade-subscription-success': (username: string, pk: string) => `/${username}/subscribers/${pk}/upgrade-success`,
    'subscription-success': (username: string, pk: string) => `/${username}/subscribers/${pk}/success`,
    'email-for-subscriber': (username: string, pk: string, slug: string) => `/${username}/subscribers/${pk}/archive/${slug}`,
    'request-subscriber-magic-link': (username: string, pk: string) => `/${username}/subscribers/${pk}/request-magic-link/`,
    'archive-for-subscriber': (username: string, pk: string) => `/${username}/subscribers/${pk}/archive`,
    'purchase-paid-subscription': (username: string) => `/${username}/buy`,
    'survey-response-freeform-source': (username: string, subscriber_id: string, survey_id: string, source: string) => `/${username}/subscribers/${subscriber_id}/surveys/${survey_id}/sources/${source}`,
    'survey-response-freeform': (username: string, subscriber_id: string, email_id: string, survey_id: string) => `/${username}/subscribers/${subscriber_id}/emails/${email_id}/surveys/${survey_id}`,
    'portal-dashboard': () => `/portal/dashboard`,
    'portal': () => `/portal`,
    'portal-magic-link': () => `/portal/magic-link`,
    'portal-authenticate': (token: string) => `/portal/auth/${token}`,
    'answer-survey-source': (username: string, subscriber_id: string, survey_id: string, source: string, answer: number) => `/${username}/subscribers/${subscriber_id}/surveys/${survey_id}/sources/${source}/answers/${answer}/record-survey-answer`,
    'answer-survey': (username: string, subscriber_id: string, email_id: string, survey_id: string, answer: number) => `/${username}/subscribers/${subscriber_id}/emails/${email_id}/surveys/${survey_id}/answers/${answer}/record-survey-answer`,
    'upgrade-subscription': (username: string, pk: string) => `/${username}/subscribers/${pk}/upgrade/monthly`,
    'public-archive': (username: string) => `/${username}/archive/`,
    'email-via-id-with-no-slash': (username: string, pk: string) => `/${username}/archive/${pk}`,
    'email-via-id': (username: string, pk: string) => `/${username}/archive/${pk}/`,
    'email': (username: string, slug: string) => `/${username}/archive/${slug}/`,
    'public-archive-login': (username: string) => `/${username}/archive/auth/login/`,
    'page': (username: string, slug: string) => `/${username}/pages/${slug}`,
    'email-via-curated-pattern': (username: string, secondary_id: number) => `/${username}/issues/${secondary_id}`,
    'email-via-substack-pattern': (username: string, slug: string) => `/${username}/p/${slug}`,
    'delete-comment': (username: string, email_slug: string, comment_id: string) => `/${username}/archive/${email_slug}/comment/${comment_id}/delete`,
    'comment': (username: string, email_slug: string, comment_id: string) => `/${username}/archive/${email_slug}/comment/${comment_id}`,
    'register-comment': (username: string, email_slug: string) => `/${username}/archive/${email_slug}/comment`,
    'raw-email': (username: string) => `/refer/${username}`,
    'app': () => `/webhooks/new`,
    'register': () => `/api/emails/register`,
    'get-averaged-publish-time': () => `/api/emails/get_averaged_publish_time`,
    'get-subscriber-count': () => `/api/emails/get_subscriber_count`,
    'render-subscribe-template': () => `/api/emails/render_subscribe_template`,
    'newsletter-qr-code': (newsletter_id: string) => `/api/emails/newsletters/${newsletter_id}/qr-code`,
    'send-test-custom-email': () => `/api/emails/send_test_custom_email`,
    'send-test-rss-email': () => `/api/emails/send_test_rss_email`,
    'retrieve-rss-items': () => `/api/emails/retrieve_rss_items`,
    'generate-alt-text': () => `/api/emails/generate_alt_text`,
    'generate-description': () => `/api/emails/generate_description`,
    'aggregate': (model: string) => `/api/emails/aggregate/${model}`,
    'customer-portal': () => `/api/emails/customer-portal`,
    'upgrade-newsletter': () => `/api/emails/upgrade-newsletter`,
    'stripe-connect-callback': () => `/api/emails/stripe-connect-callback`,
    'check-urls': () => `/api/emails/check-urls`,
    'check-internal-links': () => `/api/emails/check-internal-links`,
    'resend-confirmation-email': () => `/api/emails/resend-confirmation-email`,
    'disconnect-stripe-account': () => `/api/emails/disconnect-stripe-account`,
    'send-test-email': () => `/api/emails/send-test-email`,
    'invoice': (invoice_id: string) => `/api/emails/invoice/${invoice_id}`,
    'volume-based-billing-receipts': () => `/api/emails/volume-based-billing-receipts`,
    'capture-forwarded-draft': () => `/api/emails/capture-forwarded-draft`,
    'canary': (subscriber_id: string, email_id: string) => `/api/emails/canary/${subscriber_id}/${email_id}/`,
    'embed-metadata': (handle: string) => `/api/emails/embed-metadata/${handle}`,
    'create-subscriber': () => `/api/emails/create-subscriber`,
    'subscribe-from-embedded-form': (username: string) => `/api/emails/embed-subscribe/${username}`,
    'update-subscription-payment-method': (subscriber_id: string) => `/api/emails/subscriptions/${subscriber_id}/payment-method`,
    'change-subscription-plan': (subscriber_id: string) => `/api/emails/subscriptions/${subscriber_id}/change-plan`,
    'reactivate-subscription': (subscriber_id: string) => `/api/emails/subscriptions/${subscriber_id}/reactivate`,
    'cancel-subscription': (subscriber_id: string) => `/api/emails/subscriptions/${subscriber_id}/cancel`,
    'resume-subscription': (subscriber_id: string) => `/api/emails/subscriptions/${subscriber_id}/resume`,
    'pause-subscription': (subscriber_id: string) => `/api/emails/subscriptions/${subscriber_id}/pause`,
    'manage-premium-subscription': (subscriber_id: string) => `/api/emails/manage-premium-subscription/${subscriber_id}`,
    'confirm-invitation': (invitation_id: string) => `/api/emails/invitations/${invitation_id}`,
    'confirm-registration': (confirmation_id: string) => `/api/emails/confirm-registration/${confirmation_id}`,
    'oembed': () => `/embed`,
    'django': () => `/django`,
    'plain-webhook': () => `/plain/webhook/`,
    'sendgrid-webhook': () => `/mailgun_events/sendgrid`,
    'postmark-webhook': () => `/mailgun_events/postmark`,
    'mailgun-inbound-webhook': () => `/mailgun_events/mailgun-inbound`,
    'permanently-failed-webhook': () => `/mailgun_events/permanently-failed`,
    'failed-webhook': () => `/mailgun_events/failed`,
    'mailgun-v3-webhook': () => `/mailgun_events/mailgun-v3`,
    'tracking-domain-validation': () => `/.well-known/buttondown-tracking-domain`,
    'cloudfront-certificate-validation-redirect': (path: string) => `/.well-known/${path}`,
    'password_reset_complete': () => `/accounts/password/reset_complete/`,
    'password_reset_confirm': (uidb64: string, token: string) => `/accounts/password/reset_confirm/${uidb64}-${token}/`,
    'password_reset_done': () => `/accounts/password/reset_done/`,
    'password_reset': () => `/accounts/password/reset/`,
    'password_set_done': () => `/accounts/password/set/done/`,
    'password_set': () => `/accounts/password/set/`,
    'password_change_done': () => `/accounts/password/done/`,
    'password_change': () => `/accounts/password/change/`,
    'internal-kyc-reject': () => `/internal/kyc/reject/`,
    'internal-kyc-permanently-reject': () => `/internal/kyc/permanently-reject/`,
    'internal-kyc-permanently-approve': () => `/internal/kyc/permanently-approve/`,
    'internal-kyc-approve-requiring-custom-domain': () => `/internal/kyc/approve-requiring-custom-domain/`,
    'internal-kyc-approve': () => `/internal/kyc/approve/`,
    'plain-subscribe-blocked-sender': () => `/plain/subscribe-blocked-sender/`,
    'plain-enable-hidden-setting': (setting: string) => `/plain/enable-hidden-setting/${setting}/`,
    'plain-reject-newsletter': () => `/plain/reject-newsletter/`,
    'plain-permanently-reject-newsletter': () => `/plain/permanently-reject-newsletter/`,
    'plain-grant-free-month': () => `/plain/grant-free-month/`,
    'plain-permanently-approve-newsletter': () => `/plain/permanently-approve-newsletter/`,
    'plain-disable-double-opt-in': () => `/plain/disable-double-opt-in/`,
    'plain-cancel-and-refund-author': () => `/plain/cancel-and-refund-author/`,
    'plain-approve-newsletter': () => `/plain/approve-newsletter/`,
    'register-webmention': () => `/webmentions/register`,
    'render': () => `/markdown/render`,
    'up': () => `/up`,
    'twitter_oauth2_callback': () => `/accounts/twitter_oauth2/login/callback/`,
    'twitter_oauth2_login': () => `/accounts/twitter_oauth2/login/`,
    'tumblr_callback': () => `/accounts/tumblr/login/callback/`,
    'tumblr_login': () => `/accounts/tumblr/login/`,
    'patreon_callback': () => `/accounts/patreon/login/callback/`,
    'patreon_login': () => `/accounts/patreon/login/`,
    'mailchimp_callback': () => `/accounts/mailchimp/login/callback/`,
    'mailchimp_login': () => `/accounts/mailchimp/login/`,
    'google_callback': () => `/accounts/google/login/callback/`,
    'google_login': () => `/accounts/google/login/`,
    'discord_webhook_callback': () => `/accounts/discord_webhook/login/callback/`,
    'discord_webhook_login': () => `/accounts/discord_webhook/login/`,
    'arena_callback': () => `/accounts/arena/login/callback/`,
    'arena_login': () => `/accounts/arena/login/`,
    'apple_callback': () => `/accounts/apple/login/callback/`,
    'apple_login': () => `/accounts/apple/login/`,
    'apple_finish_callback': () => `/accounts/apple/login/finish_callback/`,
    'socialaccount_login_cancelled': () => `/accounts/login/`,
    'linkedin_login': (provider_id: string) => `/accounts/${provider_id}/login/`,
    'openid_connect_callback': (provider_id: string) => `/accounts/${provider_id}/login/callback`,
    'socialaccount_connections': () => `/accounts/connections/`,
    'account_login': () => `/accounts/login/`,
    'auth_passkey_mfa_begin': () => `/api/auth/passkey/mfa/begin/`,
    'auth_passkey_login_complete': () => `/api/auth/passkey/login/complete/`,
    'auth_passkey_login_begin': () => `/api/auth/passkey/login/begin/`,
    'auth_logout': () => `/api/auth/logout/`,
    'auth_login': () => `/api/auth/login/`,
    'oauth_token': () => `/oauth/token`,
    'oauth_authorize': () => `/oauth/authorize`,
    'internal-api:api-root': () => `/api/emails/api/`,
    'internal-api:delete_webauthn_credential': (id: string) => `/api/emails/api/webauthn-credentials/${id}`,
    'internal-api:update_webauthn_credential': (id: string) => `/api/emails/api/webauthn-credentials/${id}`,
    'internal-api:registration_complete': () => `/api/emails/api/webauthn-credentials/register/complete`,
    'internal-api:registration_begin': () => `/api/emails/api/webauthn-credentials/register/begin`,
    'internal-api:list_webauthn_credentials': () => `/api/emails/api/webauthn-credentials/`,
    'internal-api:validations': (email_id: string) => `/api/emails/api/validators/${email_id}`,
    'internal-api:list_undeliverability_reasons': () => `/api/emails/api/undeliverability-reasons`,
    'internal-api:skip_todo': (todo_id: string) => `/api/emails/api/todos/${todo_id}/skip`,
    'internal-api:get_todos': () => `/api/emails/api/todos`,
    'internal-api:reply_to_support_conversation': (inbox_item_id: string) => `/api/emails/api/support-conversations/${inbox_item_id}/reply`,
    'internal-api:list_support_messages': (inbox_item_id: string) => `/api/emails/api/support-conversations/${inbox_item_id}/messages`,
    'internal-api:delete_subscriber_import': (id: string) => `/api/emails/api/subscriber-imports/${id}`,
    'internal-api:update_subscriber_import': (id: string) => `/api/emails/api/subscriber-imports/${id}`,
    'internal-api:get_subscriber_import_text': (id: string) => `/api/emails/api/subscriber-imports/${id}/text`,
    'internal-api:create_subscriber_import': () => `/api/emails/api/subscriber-imports`,
    'internal-api:list_subscriber_imports': () => `/api/emails/api/subscriber-imports`,
    'internal-api:list_subscriber_domains': () => `/api/emails/api/subscriber-domains`,
    'internal-api:list_stripe_subscriptions': () => `/api/emails/api/stripe/subscriptions`,
    'internal-api:create_search': () => `/api/emails/api/search`,
    'internal-api:list_referrer_urls': () => `/api/emails/api/referrer-urls`,
    'internal-api:create_referral': () => `/api/emails/api/referrals`,
    'internal-api:list_referrals': () => `/api/emails/api/referrals`,
    'internal-api:recovery_code_status': () => `/api/emails/api/recovery-codes/status`,
    'internal-api:delete_recovery_codes': () => `/api/emails/api/recovery-codes/`,
    'internal-api:generate_recovery_codes': () => `/api/emails/api/recovery-codes/`,
    'internal-api:update_product': (product_id: string) => `/api/emails/api/products/${product_id}`,
    'internal-api:list_products': () => `/api/emails/api/products`,
    'internal-api:list_payouts': () => `/api/emails/api/payouts`,
    'internal-api:list_members': () => `/api/emails/api/patreon/members`,
    'internal-api:list_tiers': () => `/api/emails/api/patreon/tiers`,
    'internal-api:list_campaigns': () => `/api/emails/api/patreon/campaigns`,
    'internal-api:search_referral_usernames': () => `/api/emails/api/onboarding/referral-usernames`,
    'internal-api:fetch_metadata_endpoint': () => `/api/emails/api/onboarding/metadata`,
    'internal-api:set_active_newsletter': (id: string) => `/api/emails/api/newsletters/${id}/set-active`,
    'internal-api:cancel_newsletter_deletion': (id: string) => `/api/emails/api/newsletters/${id}/cancel-deletion`,
    'internal-api:list_newsletter_design_history': (id: string) => `/api/emails/api/newsletters/${id}/design/history`,
    'internal-api:delete_newsletter': (id: string) => `/api/emails/api/newsletters/${id}`,
    'internal-api:update_newsletter': (id: string) => `/api/emails/api/newsletters/${id}`,
    'internal-api:retrieve_mentions': () => `/api/emails/api/mentions`,
    'internal-api:list_memberful_subscriptions': () => `/api/emails/api/memberful/subscriptions`,
    'internal-api:list_memberful_plans': () => `/api/emails/api/memberful/plans`,
    'internal-api:list_invoices': () => `/api/emails/api/invoices`,
    'internal-api:get_happenings': () => `/api/emails/api/happenings`,
    'internal-api:replay_external_event': (id: string) => `/api/emails/api/events/${id}/replay`,
    'internal-api:list_external_events': () => `/api/emails/api/events`,
    'internal-api:delete_inbox_item_route': (item_id: string) => `/api/emails/api/inbox/${item_id}`,
    'internal-api:update_inbox_item': (item_id: string) => `/api/emails/api/inbox/${item_id}`,
    'internal-api:retrieve_inbox_item': (item_id: string) => `/api/emails/api/inbox/${item_id}`,
    'internal-api:list_inbox_items': () => `/api/emails/api/inbox`,
    'internal-api:create_image_from_url': () => `/api/emails/api/images/from-url`,
    'internal-api:retrieve_email_render': (id: string) => `/api/emails/api/email-renders/${id}`,
    'internal-api:create_email_render': () => `/api/emails/api/email-renders`,
    'internal-api:list_render_clients': () => `/api/emails/api/email-renders/clients`,
    'internal-api:delete_draft_recipient': (id: string) => `/api/emails/api/draft-recipients/${id}`,
    'internal-api:create_draft_recipient': () => `/api/emails/api/draft-recipients`,
    'internal-api:list_draft_recipients': () => `/api/emails/api/draft-recipients`,
    'internal-api:get_sending_domain_zone_file': (domain: string) => `/api/emails/api/domains/sending/${domain}/zone-file`,
    'internal-api:get_sending_domain': (domain: string) => `/api/emails/api/domains/sending/${domain}`,
    'internal-api:get_hosting_domain': (domain: string) => `/api/emails/api/domains/hosting/${domain}`,
    'internal-api:retrieve_domain': (domain: string) => `/api/emails/api/domains/${domain}`,
    'internal-api:send_reply': (conversation_id: string) => `/api/emails/api/conversations/${conversation_id}/reply`,
    'internal-api:retrieve_messages': (conversation_id: string) => `/api/emails/api/conversations/${conversation_id}/messages`,
    'internal-api:update_conversation': (conversation_id: string) => `/api/emails/api/conversations/${conversation_id}`,
    'internal-api:retrieve_conversation': (conversation_id: string) => `/api/emails/api/conversations/${conversation_id}`,
    'internal-api:retrieve_conversations': () => `/api/emails/api/conversations`,
    'internal-api:disconnect': () => `/api/emails/api/bluesky_standard_site`,
    'internal-api:sync_publication': () => `/api/emails/api/bluesky_standard_site`,
    'internal-api:get_status': () => `/api/emails/api/bluesky_standard_site`,
    'internal-api:get_blockers': () => `/api/emails/api/blockers`,
    'internal-api:delete_authentication_token': (id: string) => `/api/emails/api/authentication_tokens/${id}`,
    'internal-api:update_authentication_token': (id: string) => `/api/emails/api/authentication_tokens/${id}`,
    'internal-api:connect_authentication_token': () => `/api/emails/api/authentication_tokens/connect`,
    'internal-api:create_authentication_token': () => `/api/emails/api/authentication_tokens/`,
    'internal-api:list_authentication_tokens': () => `/api/emails/api/authentication_tokens/`,
    'internal-api:delete_archive_import': (id: string) => `/api/emails/api/archive-imports/${id}`,
    'internal-api:update_archive_import': (id: string) => `/api/emails/api/archive-imports/${id}`,
    'internal-api:retrieve_archive_import': (id: string) => `/api/emails/api/archive-imports/${id}`,
    'internal-api:create_archive_import_upload': () => `/api/emails/api/archive-imports/upload`,
    'internal-api:create_archive_import': () => `/api/emails/api/archive-imports`,
    'internal-api:list_archive_imports': () => `/api/emails/api/archive-imports`,
    'internal-api:regenerate_api_key': (id: string) => `/api/emails/api/api-keys/${id}/regenerate`,
    'internal-api:delete_api_key': (id: string) => `/api/emails/api/api-keys/${id}`,
    'internal-api:update_api_key': (id: string) => `/api/emails/api/api-keys/${id}`,
    'internal-api:create_api_key': () => `/api/emails/api/api-keys/`,
    'internal-api:list_api_keys': () => `/api/emails/api/api-keys/`,
    'internal-api:retrieve_analytics': (metric: string) => `/api/emails/api/analytics/${metric}`,
    'internal-api:remove_password': (id: string) => `/api/emails/api/account/${id}/password`,
    'internal-api:disconnect_auth_connection': (id: string, provider: string) => `/api/emails/api/account/${id}/connections/auth/${provider}`,
    'internal-api:disconnect_connection_by_id': (id: string, connection_id: string) => `/api/emails/api/account/${id}/connections/by-id/${connection_id}`,
    'internal-api:disconnect_connection': (id: string, provider: string) => `/api/emails/api/account/${id}/connections/${provider}`,
    'internal-api:delete_account': (id: string) => `/api/emails/api/account/${id}`,
    'internal-api:update_account': (id: string) => `/api/emails/api/account/${id}`,
    'internal-api:retrieve_account': (id: string) => `/api/emails/api/account/${id}`,
    'internal-api:openapi-view': () => `/api/emails/api/docs`,
    'internal-api:openapi-json': () => `/api/emails/api/openapi.json`,
    'api:api-root': () => `/v1/`,
    'api:test_webhook': (id: string) => `/v1/webhooks/${id}/test`,
    'api:retrieve_webhook_attempts': (id: string) => `/v1/webhooks/${id}/attempts`,
    'api:delete_webhook': (id: string) => `/v1/webhooks/${id}`,
    'api:update_webhook': (id: string) => `/v1/webhooks/${id}`,
    'api:retrieve_webhook': (id: string) => `/v1/webhooks/${id}`,
    'api:list_webhooks': () => `/v1/webhooks`,
    'api:create_webhook': () => `/v1/webhooks`,
    'api:update_user': (id: string) => `/v1/users/${id}`,
    'api:delete_user': (id: string) => `/v1/users/${id}`,
    'api:retrieve_user': (id: string) => `/v1/users/${id}`,
    'api:list_users': () => `/v1/users`,
    'api:create_user': () => `/v1/users`,
    'api:retrieve_tag_analytics': (id: string) => `/v1/tags/${id}/analytics`,
    'api:delete_tag': (id: string) => `/v1/tags/${id}`,
    'api:update_tag': (id: string) => `/v1/tags/${id}`,
    'api:retrieve_tag': (id: string) => `/v1/tags/${id}`,
    'api:list_tags': () => `/v1/tags`,
    'api:create_tag': () => `/v1/tags`,
    'api:delete_survey': (id: string) => `/v1/surveys/${id}`,
    'api:update_survey': (id: string) => `/v1/surveys/${id}`,
    'api:retrieve_survey': (id: string) => `/v1/surveys/${id}`,
    'api:list_surveys': () => `/v1/surveys`,
    'api:create_survey': () => `/v1/surveys`,
    'api:update_survey_response': (id: string) => `/v1/survey_responses/${id}`,
    'api:create_survey_response': () => `/v1/survey_responses`,
    'api:retrieve_survey_responses': () => `/v1/survey_responses`,
    'api:get_stripe_subscriptions': (id_or_email: string) => `/v1/subscribers/${id_or_email}/stripe-subscriptions`,
    'api:update_automation_attempt': (id_or_email: string, automation_attempt_id: string) => `/v1/subscribers/${id_or_email}/automations/${automation_attempt_id}`,
    'api:get_automations': (id_or_email: string) => `/v1/subscribers/${id_or_email}/automations`,
    'api:get_referrals': (id_or_email: string) => `/v1/subscribers/${id_or_email}/referrals`,
    'api:send_email_to': (id_or_email: string, email_id: string) => `/v1/subscribers/${id_or_email}/emails/${email_id}`,
    'api:send_magic_link_to_subscriber': (id_or_email: string) => `/v1/subscribers/${id_or_email}/send-magic-link`,
    'api:send_reminder': (id_or_email: string) => `/v1/subscribers/${id_or_email}/send-reminder`,
    'api:update_subscriber': (id_or_email: string) => `/v1/subscribers/${id_or_email}`,
    'api:delete_subscriber': (id_or_email: string) => `/v1/subscribers/${id_or_email}`,
    'api:retrieve_subscriber': (id_or_email: string) => `/v1/subscribers/${id_or_email}`,
    'api:list_subscribers': () => `/v1/subscribers`,
    'api:create_subscriber': () => `/v1/subscribers`,
    'api:delete_snippet': (id: string) => `/v1/snippets/${id}`,
    'api:update_snippet': (id: string) => `/v1/snippets/${id}`,
    'api:retrieve_snippet': (id: string) => `/v1/snippets/${id}`,
    'api:list_snippets': () => `/v1/snippets`,
    'api:create_snippet': () => `/v1/snippets`,
    'api:list_public_emails': (username: string) => `/v1/public/emails/${username}`,
    'api:delete_price': (price_id: string) => `/v1/prices/${price_id}`,
    'api:create_price': () => `/v1/prices`,
    'api:list_prices': () => `/v1/prices`,
    'api:ping': () => `/v1/ping`,
    'api:delete_note_endpoint': (id: string) => `/v1/notes/${id}`,
    'api:list_notes': () => `/v1/notes`,
    'api:create_note_endpoint': () => `/v1/notes`,
    'api:delete_newsletter': (id: string) => `/v1/newsletters/${id}`,
    'api:update_newsletter': (id: string) => `/v1/newsletters/${id}`,
    'api:create_newsletter': () => `/v1/newsletters`,
    'api:list_newsletters': () => `/v1/newsletters`,
    'api:delete_import': (id: string) => `/v1/imports/${id}`,
    'api:update_import': (id: string) => `/v1/imports/${id}`,
    'api:retrieve_import': (id: string) => `/v1/imports/${id}`,
    'api:create_import': () => `/v1/imports`,
    'api:list_imports': () => `/v1/imports`,
    'api:delete_image': (id: string) => `/v1/images/${id}`,
    'api:update_image': (id: string) => `/v1/images/${id}`,
    'api:list_images': () => `/v1/images`,
    'api:create_image': () => `/v1/images`,
    'api:delete_form': (id: string) => `/v1/forms/${id}`,
    'api:update_form': (id: string) => `/v1/forms/${id}`,
    'api:retrieve_form': (id: string) => `/v1/forms/${id}`,
    'api:list_forms': () => `/v1/forms`,
    'api:create_form': () => `/v1/forms`,
    'api:retrieve_items': (id: string) => `/v1/external_feeds/${id}/items`,
    'api:poll_items': (id: string) => `/v1/external_feeds/${id}/items`,
    'api:retrieve_external_feed': (id: string) => `/v1/external_feeds/${id}`,
    'api:delete_external_feed': (id: string) => `/v1/external_feeds/${id}`,
    'api:update_external_feed': (id: string) => `/v1/external_feeds/${id}`,
    'api:list_external_feed': () => `/v1/external_feeds`,
    'api:create_external_feed': () => `/v1/external_feeds`,
    'api:retrieve_export': (id: string) => `/v1/exports/${id}`,
    'api:list_exports': () => `/v1/exports`,
    'api:create_export': () => `/v1/exports`,
    'api:get_event': (id: string) => `/v1/events/${id}`,
    'api:list_events': () => `/v1/events`,
    'api:publish_email': (id: string) => `/v1/emails/${id}/publish`,
    'api:send_draft': (id: string) => `/v1/emails/${id}/send-draft`,
    'api:retrieve_email_renders': (id: string) => `/v1/emails/${id}/renders`,
    'api:retrieve_email_analytics': (id: string) => `/v1/emails/${id}/analytics`,
    'api:retrieve_email_history_by_id': (id: string, history_id: string) => `/v1/emails/${id}/history/body/${history_id}`,
    'api:retrieve_email_history': (id: string) => `/v1/emails/${id}/history`,
    'api:delete_email': (id: string) => `/v1/emails/${id}`,
    'api:retrieve_email': (id: string) => `/v1/emails/${id}`,
    'api:update_email': (id: string) => `/v1/emails/${id}`,
    'api:list_emails': () => `/v1/emails`,
    'api:create_email': () => `/v1/emails`,
    'api:list_coupons': () => `/v1/coupons`,
    'api:delete_comment': (id: string) => `/v1/comments/${id}`,
    'api:update_comment': (id: string) => `/v1/comments/${id}`,
    'api:retrieve_comment': (id: string) => `/v1/comments/${id}`,
    'api:list_comments': () => `/v1/comments`,
    'api:create_comment': () => `/v1/comments`,
    'api:retrieve_bulk_action': (id: string) => `/v1/bulk_actions/${id}`,
    'api:create_bulk_action': () => `/v1/bulk_actions`,
    'api:delete_book': (id: string) => `/v1/books/${id}`,
    'api:update_book': (id: string) => `/v1/books/${id}`,
    'api:retrieve_book': (id: string) => `/v1/books/${id}`,
    'api:list_books': () => `/v1/books`,
    'api:create_book': () => `/v1/books`,
    'api:retrieve_automation_analytics': (id: string) => `/v1/automations/${id}/analytics`,
    'api:invoke_automation': (id: string) => `/v1/automations/${id}/invoke`,
    'api:delete_automation': (id: string) => `/v1/automations/${id}`,
    'api:update_automation': (id: string) => `/v1/automations/${id}`,
    'api:retrieve_automation': (id: string) => `/v1/automations/${id}`,
    'api:create_automation': () => `/v1/automations`,
    'api:list_automations': () => `/v1/automations`,
    'api:delete_attachment': (id: string) => `/v1/attachments/${id}`,
    'api:retrieve_attachment': (id: string) => `/v1/attachments/${id}`,
    'api:list_attachments': () => `/v1/attachments`,
    'api:create_attachment': () => `/v1/attachments`,
    'api:list_api_requests': () => `/v1/api_requests`,
    'api:retrieve_api_request': (id: string) => `/v1/api_requests/${id}`,
    'api:update_advertising_slot': (id: string) => `/v1/advertising_units/slots/${id}`,
    'api:list_advertising_slots': () => `/v1/advertising_units/slots`,
    'api:delete_advertising_unit': (id: string) => `/v1/advertising_units/${id}`,
    'api:update_advertising_unit': (id: string) => `/v1/advertising_units/${id}`,
    'api:create_advertising_unit': () => `/v1/advertising_units`,
    'api:list_advertising_units': () => `/v1/advertising_units`,
    'api:get_account': () => `/v1/accounts/me`,
    'api:openapi-view': () => `/v1/docs`,
    'api:openapi-json': () => `/v1/openapi.json`,
    'linear:webhook': () => `/linear/webhook/`,
    'github:webhook': () => `/github/webhook/`,
};
export default URLS;
